import { registerDe } from '../i18n/index.js';

registerDe({
  'Context': 'Kontext',
  '— every organisation —': '— alle Organisationen —',
}, 'AppShell');
